// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search-result[data-v-c98bdf24]:first-child {\n  margin-top: 24px;\n  border-radius: 4px 4px 0px 0px;\n}\n.search-result[data-v-c98bdf24]:not(:first-child) {\n  border-top: 1px solid gray;\n}\n.search-result[data-v-c98bdf24]:last-child {\n  border-radius: 0px 0px 4px 4px;\n}\n.resultSize[data-v-c98bdf24] {\n  margin-right: 12px;\n}\n.result-title[data-v-c98bdf24]:hover {\n  text-decoration: underline;\n}\n.result-item[data-v-c98bdf24] {\n  cursor: initial;\n}", ""]);
// Exports
module.exports = exports;
